module.exports = __webpack_public_path__ + "bedroom-quilt1.ecc74291.png";